import { useState, useMemo } from 'react';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import '../../../styles/range.css';

const { Range: RcRange } = Slider;

const handleStyle = {
  width: '1.5rem',
  height: '1.5rem',
  marginTop: '-10px',
  border: '0',
  backgroundColor: '#54B8C8',
};
const trackStyle = {
  backgroundColor: '#54B8C8',
};

export default function FloatRange({
  id,
  name,
  attrs,
  label,
  setVariablesState,
  initialState,
}) {
  const step = attrs.step ? parseFloat(attrs.step) : 0.1;
  const multiplier = 1 / step;
  const decimals = step < 1 ? String(step).split('.')[1]?.length || 0 : 0;

  const initialMin = parseFloat(attrs.min);
  const initialMax = parseFloat(attrs.max);

  const [range, setRange] = useState(() => {
    if (typeof setVariablesState === 'function') {
      if (initialState) {
        setVariablesState(initialState, { loadingInitialState: true });
        return [initialState.min, initialState.max];
      }
      setVariablesState({ min: initialMin, max: initialMax });
    }
    return [initialMin, initialMax];
  });

  const min = useMemo(() => range[0], [range]);
  const max = useMemo(() => range[1], [range]);

  function handleChange(value) {
    setRange([value[0] / multiplier, value[1] / multiplier]);
  }

  function handleAfterChange(value) {
    if (typeof setVariablesState === 'function') {
      setVariablesState({
        min: value[0] / multiplier,
        max: value[1] / multiplier,
      });
    }
  }

  const sliderValue = [min * multiplier, max * multiplier];

  return (
    <div className="flex flex-col flex-grow w-full border-l-2 border-gray-400 pl-2 mb-2">
      <div className="flex justify-between items-center mb-1">
        <span>{name}</span>
        <div className="flex items-center gap-1 ml-2">
          <input
            type="number"
            step={step}
            value={min}
            min={initialMin}
            max={max}
            onChange={(e) => {
              const val = parseFloat(e.target.value);
              if (!isNaN(val)) {
                setRange([val, max]);
              }
            }}
            onBlur={() => {
              let [newMin, newMax] = [
                Math.max(initialMin, Math.min(initialMax, min)),
                Math.max(initialMin, Math.min(initialMax, max)),
              ].sort((a, b) => a - b);
              newMin = parseFloat(newMin.toFixed(decimals));
              newMax = parseFloat(newMax.toFixed(decimals));
              setRange([newMin, newMax]);
              handleAfterChange([newMin * multiplier, newMax * multiplier]);
            }}
            className="hide-arrows py-1 px-1 rounded-lg bg-gray-200 text-gray-700 w-20 text-center focus:outline-none focus:ring-1 focus:ring-cyan-500"
          />
          <span className="text-gray-400">-</span>
          <input
            type="number"
            step={step}
            value={max}
            min={min}
            max={initialMax}
            onChange={(e) => {
              const val = parseFloat(e.target.value);
              if (!isNaN(val)) {
                setRange([min, val]);
              }
            }}
            onBlur={() => {
              let [newMin, newMax] = [
                Math.max(initialMin, Math.min(initialMax, min)),
                Math.max(initialMin, Math.min(initialMax, max)),
              ].sort((a, b) => a - b);
              newMin = parseFloat(newMin.toFixed(decimals));
              newMax = parseFloat(newMax.toFixed(decimals));
              setRange([newMin, newMax]);
              handleAfterChange([newMin * multiplier, newMax * multiplier]);
            }}
            className="hide-arrows py-1 px-1 rounded-lg bg-gray-200 text-gray-700 w-20 text-center focus:outline-none focus:ring-1 focus:ring-cyan-500"
          />
        </div>
      </div>
      <div className="py-2 px-2">
        <RcRange
          defaultValue={sliderValue}
          min={initialMin * multiplier}
          max={initialMax * multiplier}
          allowCross={true}
          value={sliderValue}
          onChange={handleChange}
          onAfterChange={handleAfterChange}
          trackStyle={[trackStyle, trackStyle]}
          handleStyle={[handleStyle, handleStyle]}
          railStyle={{ backgroundColor: '#E5E7EB' }}
        />
      </div>
      <div className="flex justify-between text-gray-500">
        <span>{initialMin.toFixed(decimals)}</span>
        {label && <span className="px-2 whitespace-nowrap">{label}</span>}
        <span>{initialMax.toFixed(decimals)}</span>
      </div>
    </div>
  );
}
